/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_Faq_A3Inputs */

const en_guide_json_vs_yaml_xml_faq_a3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almost always. JSON drops closing tags and most punctuation, so an equivalent document is typically 30 to 50 percent smaller than XML. YAML is usually close to JSON in size.`)
};

const ko_guide_json_vs_yaml_xml_faq_a3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`거의 항상 그렇습니다. JSON은 닫는 태그와 대부분의 구두점을 없애므로 같은 내용의 문서가 보통 XML보다 30~50% 작습니다. YAML은 대체로 JSON과 크기가 비슷합니다.`)
};

const ja_guide_json_vs_yaml_xml_faq_a3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほぼ常にそうです。JSON は閉じタグとほとんどの記号を省くため、同じ内容の文書は通常 XML より30〜50パーセント小さくなります。YAML はたいてい JSON と近いサイズです。`)
};

/**
* | output |
* | --- |
* | "Almost always. JSON drops closing tags and most punctuation, so an equivalent document is typically 30 to 50 percent smaller than XML. YAML is usually close ..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_faq_a3 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_faq_a3(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_faq_a3(inputs)
	return ja_guide_json_vs_yaml_xml_faq_a3(inputs)
});